import { render, staticRenderFns } from "./vsCheckBox.vue?vue&type=template&id=bde97f28&lang=html&"
import script from "./vsCheckBox.vue?vue&type=script&lang=js&"
export * from "./vsCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports